import { render, staticRenderFns } from "./CustomerCompany.vue?vue&type=template&id=456d08fc&"
import script from "./CustomerCompany.vue?vue&type=script&lang=js&"
export * from "./CustomerCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports